import * as Types from '../../@types/graphql-types';

import gql from 'graphql-tag';
export type SetInWatchlistMutationVariables = Types.Exact<{
	input: Types.SetInTitleListInput;
	country: Types.Scalars['Country']['input'];
}>;

export type SetInWatchlistMutation = {
	__typename?: 'Mutation';
	setInWatchlist: {
		__typename?: 'SetInTitleListPayload';
		title:
			| {
					__typename?: 'Movie';
					id: string;
					watchlistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
			  }
			| {
					__typename?: 'Show';
					id: string;
					seenState: { __typename?: 'ShowSeenState'; seenEpisodeCount: number };
					seasons: Array<{
						__typename?: 'Season';
						id: string;
						show: {
							__typename?: 'Show';
							id: string;
							watchlistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
						};
					}>;
					watchlistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
			  };
	};
};

export const SetInWatchlistDocument = gql`
	mutation SetInWatchlist($input: SetInTitleListInput!, $country: Country!) {
		setInWatchlist(input: $input) {
			title {
				id
				watchlistEntry {
					createdAt
				}
				... on Show {
					seenState(country: $country) {
						seenEpisodeCount
					}
					seasons {
						id
						show {
							id
							watchlistEntry {
								createdAt
							}
						}
					}
				}
			}
		}
	}
`;
